<template>
  <div>
    <button :disabled="disabled" class="parse-btn btn btn-info sq" :id="id + 'button-csv'" @click="downloadCSV" :style="styles.csv">
      <slot name="csv"></slot>
      <span v-if="!csvSlotInUse">To CSV</span>
    </button>
    <button :disabled="disabled" class="parse-btn btn btn-info sq" :id="id + 'button-xlsx'" @click="downloadXLSX" :style="styles.xlsx">
      <slot name="xlsx"></slot>
      <span v-if="!xlsxSlotInUse">To XLSX</span>
    </button>
  </div>
</template>
<script>
  import Papa from 'papaparse'
  import XLSX from 'xlsx/xlsx'
  import FileSaver from 'file-saver'
  export default {
    name: 'ParseFromJson',
    data () {
      return {}
    },
    props: {
      fileName: {
        required: true,
        type: String
      },
      disabled: {
        required: true,
        default: true,
        type: Boolean
      },
      json: {
        type: Array,
        required: true
      },
      styles: {
        required: false,
        type: Object,
        default: function () {
          return {
            outer: {},
            csv: {},
            xlsx: {}
          }
        }
      }
    },
    computed: {
      csvSlotInUse () {
        return this.$slots.hasOwnProperty('csv')
      },
      xlsxSlotInUse () {
        return this.$slots.hasOwnProperty('xlsx')
      },
      id () {
        return `jtp-${this._uid}-`
      },
      jsonValsStringified () {
        return this.json.map(obj => {
          let o = {}
          for (let prop in obj) {
            o[prop] = this.stringify(obj[prop])
          }
          return o
        })
      }
    },
    methods: {
      canBeNumeric (n) {
        return (Number(n) !== n) && !isNaN(parseFloat(n)) && isFinite(n)
      },
      shouldPreserveZeros (v) {
        return v !== null && this.canBeNumeric(v) && v.charAt(0) == 0
      },
      stringify (val) {
        let v = val
        try {
          if (this.shouldPreserveZeros(v)) {
            v = '\'' + String(val)
          }
        } catch (e) {
          v = val
          console.log(e)
        }
        return v
      },
      downloadCSV (e) {
        e.preventDefault()
        e.stopPropagation()
        let blob = new Blob([Papa.unparse(this.jsonValsStringified)], { type: 'text/csv;charset=utf-8' })
        FileSaver.saveAs(blob, `${this.fileName}.csv`)
      },
      downloadXLSX (e) {
        e.preventDefault()
        e.stopPropagation()
        let wb = { SheetNames: ['opti'], Sheets: { 'opti': XLSX.utils.json_to_sheet(this.json) } }
        let wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })
        FileSaver.saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), `${this.fileName}.xlsx`)
      },
      s2ab (s) {
        if (typeof ArrayBuffer !== 'undefined') {
          let buf = new ArrayBuffer(s.length)
          let view = new Uint8Array(buf)
          for (let i = 0; i != s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xFF
          }
          return buf
        } else {
          let buf = new Array(s.length)
          for (let i = 0; i != s.length; ++i) {
            buf[i] = s.charCodeAt(i) & 0xFF
          }
          return buf
        }
      }
    }
  }
</script>
<style>
.parse-btn {
  width: 75px;
}
</style>



// WEBPACK FOOTER //
// ParseFromJson.vue?c85f3382